import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50c73be8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

import useHomeStore from '@/store/modules/home';
import { storeToRefs } from 'pinia';
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router';


export default {
  __name: 'bread-crumb',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const homeStore = useHomeStore()
const { breadListState, defaultTab } = storeToRefs(homeStore)

// 面包屑点击事件
const breadcrumbClick = (item) => {
  // console.log('item', item)
  // console.log('route', route.query)
  // console.log('item.path', item.path)
  router.push({
    path: item.path,
    query: route.query
  })
  if (item.path.includes('home/index')) {
    defaultTab.value = 0
  }
}

const breadList = ref([])
watch(route, () => {
  getBreadcrumb()
})


// 面包屑数据处理
const getBreadcrumb = () => {
  // let that = this;
  // 由于本项目大部分属于‘一级’页面，所以在设置路由时候，一级页面不设置breadNumber = 1，‘二级’页面以上才设置breadNumber
  let breadNumber = typeof (route.meta.breadNumber) !== 'undefined' ? route.meta.breadNumber : 1;
  console.log('breadNumber', breadNumber)
  // 获取当前页面的名字和路由，并组合成新的对象
  let newBread = { name: route.meta.breadName, path: route.fullPath };
  let vuexBreadList = []; // 默认初始化面包屑数据
  if (breadNumber !== 1) {
    // 当前面包屑breadNumber大于1时才会从vuex中获取值
    vuexBreadList = breadListState.value; // 获取breadList数组
  }
  if (breadNumber < vuexBreadList.length) {

    // "回退"面包屑----判断条件：当前路由breadNumber小于vuexBreadList的长度
    vuexBreadList.splice(breadNumber - vuexBreadList.length, vuexBreadList.length - breadNumber);
  }
  if (breadNumber == vuexBreadList.length) {
    //替换面包屑
    // console.log('替换面包屑')
    vuexBreadList.splice(vuexBreadList.length - 1, 1, newBread);
  }
  if (breadNumber > vuexBreadList.length) {
    // 特殊处理 个人空间没有面包屑
    if (newBread.name == '个人空间') {
      newBread = { name: "首页", path: "/home/index" }
    }
    // 添加面包屑----判断条件：当前路由breadNumber大于vuexBreadList的长度
    // bredNumber从1进3后刷新 会重复出来一个面包屑item解决

    if(newBread?.name == vuexBreadList[vuexBreadList.length-1]?.name){
      //nothing
    }else{
      vuexBreadList.push(newBread);
    }


  }

  // 处理完数据后，将最终的数据更新到vuex（用于页面刷新）
  // that.$store.commit('breadListMutations', vuexBreadList);
  breadListState.value = vuexBreadList
  // 处理完数据后，将最终的数据更新为新的面包屑数组
  breadList.value = vuexBreadList;
  // console.log('breadNumber', breadNumber)
  // console.log('breadList', breadList.value)
}



return (_ctx, _cache) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")

  return (_openBlock(), _createBlock(_component_el_breadcrumb, {
    class: "breadcrumb common-wrap",
    separator: ">"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadList.value, (item, index) => {
        return (_openBlock(), _createBlock(_component_el_breadcrumb_item, { key: index }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              onClick: $event => (breadcrumbClick(item))
            }, _toDisplayString(item.name), 9, _hoisted_1)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

}